import React from "react";
import styled from "styled-components";
import { TabButton } from "@sonder/ui/source/styled/fragments/TabButton";
import { TabGroup } from "@sonder/ui/source/styled/fragments/TabGroup";
import { colors } from "@sonder/ui/source/styled/theme";
import { SubjectTypeConfig } from "tasks/hooks/useCreateTaskFormConfig";

const StyledTabGroup = styled(TabGroup)`
  padding: 0 1.71rem;
`;

const StyledTabButton = styled(TabButton)`
  border-bottom-color: ${props => props.selected && colors.blue7};

  &:hover:not(:disabled) {
    border-bottom-color: ${props => !props.selected && colors.grayE};
  }

  &:active:not(:disabled) {
    border-bottom-color: ${props => !props.selected && colors.blueA};
  }
`;
interface Props {
  disabled?: boolean;
  taskSubjects: SubjectTypeConfig[];
  value: SubjectTypeConfig | null;
  onChange: (subject: SubjectTypeConfig) => void;
}

export const TaskSubjectSelection = ({
  disabled,
  taskSubjects,
  value,
  onChange,
}: Props) => {
  return (
    <StyledTabGroup>
      {taskSubjects.map(subject => (
        <StyledTabButton
          disabled={disabled}
          key={subject.subjectType}
          selected={subject.displayName === value?.displayName}
          onClick={() => onChange(subject)}
        >
          {subject.displayName}
        </StyledTabButton>
      ))}
    </StyledTabGroup>
  );
};
